<template>
	<div class="dropDown">
		<button
			@click="removeOutline"
			@contextmenu.prevent="onMenuClickRight($event)"
			v-click-outside="onMenuClickOut"
			:class="{noOutline:removeButtonOutline==true,navbarBtn:true}"
		>
		<span>{{title}}</span>

  		  <i id="caret" v-if="dropdown" class="fa fa-angle-down img"></i>
		</button>
		<div
		v-if="!dropdown"
		style="display:none;"
		class="openMe"
        id="openme"
        @click="removeOutline2">Open in new tab
	    </div>
		<div
		v-if="dropdown"
		style="display:none;"></div>
		<div v-if="dropdown" class="dropdown-content"  @mouseleave="originalImage($event)"  @mouseenter="constantImage($event)">
			<ul
				v-for="(content,i) in dropdownOptions"
				:class="{isSelected: (i == selectedIndex)}"
				:key="i"
			>
				<li
					:class="{onlyBottom:i!=0,buttonDiv:i==0}"
					class="dropdownLabel"
					@click="()=>emitClickedMenu(content.route,i)"
					v-click-outside="onMenuClickOut"
					@contextmenu.prevent="onMenuClickRight($event)"
				>{{content.name}}</li>
				<div
				style="display:none;"
				class="openMe"
        		id="openme"
        		@click="()=>emitClickedMenu2(content.route)">Open in new tab
	    		</div>
		   </ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "SNavButton",

	data(){
		return{
			selectedIndex: null,
			removeButtonOutline: false,
			label: true,
		}
	},

	methods: {
		onMenuClickOut: function (){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";

    }
		},
		onMenuClickRight: function (e) {
    var elems = document.querySelectorAll('[id=openme]');
	var sib=e.currentTarget.nextElementSibling;
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";

    }

      if(sib.style.display=='none')
      {sib.style.display='grid';}
      else
      {sib.style.display='none';

	  }

    },

		emitClickedMenu(name,i){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";
    }
			const boxes = document.querySelectorAll('.notSelected');

          boxes.forEach(notSelected => {
          notSelected.className  = 'isSelected';
            });
			this.selectedIndex = i;
			// console.log(name);
			this.$emit('clicked-menu-item', name);
		},

		emitClickedMenu2(name){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";
    }
			this.$emit('clicked-menu-item2', name);
		},

		removeOutline(){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";
    }
		const boxes = document.querySelectorAll('.isSelected');

          boxes.forEach(isSelected => {
          isSelected.className  = 'notSelected';
            });
			this.removeButtonOutline = true;
			this.$emit('clicked-menu-item', this.title);
		},
			removeOutline2(){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";
    }
			this.$emit('clicked-menu-item2', this.title);
		},
		changeImage(){
			var elems = document.querySelectorAll('[id=openme]');
    var index = 0, length = elems.length;
    for ( ; index < length; index++) {
        elems[index].style.display = "none";
    }
			var icon = document.getElementById('caret');
			if(this.open){
				icon.className = 'fa fa-angle-down open img';
			}
			else{
				icon.className = 'fa fa-angle-down img  ';
		   }

    		this.open = !this.open;
		},
		constantImage(e){
			e.target.parentElement.children[0].children[1].style.transform = 'rotate(180deg)'
			// var icon = document.getElementById('caret');
			// icon.className = 'fa fa-angle-down open img  ';
		},

		originalImage(e){
			e.target.parentElement.children[0].children[1].style.transform = 'rotate(0deg)'
			// var icon = document.getElementById('caret');
			// icon.className = 'fa fa-angle-down img  ';
			this.open = !this.open;
		}
	},

	props: {
		title: {
			type: String
		},
		dropdown: {
			type: Boolean,
			required: false
		},
		dropdownOptions: {
			type: Array,
			required: false
		}
	}
}
</script>

<style scoped>
#caret{
	transition: all 0.4s linear;
}
.navbarBtn{
  font-family: "Roboto !important";
	font-size: 11px;
	height:100%;
	border: none;
	text-align: center;
	cursor: pointer;
	font-weight: normal;
	padding: 0 5px 0 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 6px;
	width: 100%;
	background-color: #fff;
}

.dropDown, .dropDown:hover{
	width:100%;
	height:100%;
	cursor: pointer;
	position: relative;
}

.navbarBtn:focus, .navbarBtn:active{
	outline: 0;
}

.noOutline{
	outline: 0;
}

.fa-angle-down{
  transform: rotate(0deg);
}

.fa-angle-down.open{
  transform: rotate(180deg);
}

.img{
 position: relative;
 font-size: x-large;
 color: #979797;
}



.dropDown:hover .dropdown-content {
	display: block;
}

.dropdown-content {
  display: none;
  position: absolute;
  left: 0%;
  background-color: #ffffff;
  box-shadow: 0 0 11px 0 #e1e1e1;
  text-align: start;
  margin-top: 4px;
  /* min-width: fit-content; */
  width:100%;
  animation: dropContentFrames 0.4s linear;
  transform-origin: top;
}
@keyframes dropContentFrames {
	0%{ opacity: 0; transform: scale(0.9,0.9); }
	100%{ opacity: 1; transform: scale(1,1); }
}
.dropdown-content li{
	list-style: none;
	margin: 0;
}

.dropdown-content ul:hover {
  background-color: #f4f4f4;
  border-bottom: 2px solid var(--primary) !important;
}

ul{
	padding-left: 0px;
	margin: 0px;
	border-bottom: 2px solid transparent !important;
}

.dropdownLabel{
	font-family: "Roboto !important";
    font-size: 12px;
    padding: 8px;
}
.isSelected{
	border-bottom: 2px solid var(--primary);
	outline: none !important;
}
.notSelected{
	border-bottom: 0px solid var(--primary);
	outline: none !important;
}
#openme{
    position: fixed;
    background-color: white;
    z-index: 1;
    box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
    border-radius: 8px;
    min-height: fit-content;
    margin-left: 60px;
    margin-top: -5px;
	padding:10px;
}

.openMe:hover{
	background-color: #eaf1f1 !important;
	cursor: pointer;

	}



@media screen and (min-width:850px) and (max-width:980px) {
	.navbarBtn{	font-size: 13px; padding: 0 5px 0 5px;	}
	.dropdownLabel{   font-size: 13px;    padding: 8px;	}
}
@media screen and (min-width:980px) and (max-width:1150px) {
	.navbarBtn{	font-size: 14px; padding: 0 4px 0 4px;	}
	.dropdownLabel{   font-size: 16px;    padding: 10px;	}
}
@media screen and (min-width:1150px) and (max-width:1250px) {
	.navbarBtn{	font-size: 15px; padding: 0 4px 0 4px;	}
	.dropdownLabel{   font-size: 16px;    padding: 10px;	}
}
@media screen and (min-width:1250px) {
	.navbarBtn{	font-size: 16px; padding: 0 4px 0 4px;	}
	.dropdownLabel{   font-size: 16px;    padding: 12px;	}
}


</style>
